import { put, takeEvery } from "redux-saga/effects";

import {
  FETCH_DISTRIBUTORS_INIT_ACTION,
  FETCH_DISTRIBUTORS_SUCCESS_ACTION,
  FETCH_DISTRIBUTORS_FAIL_ACTION,
  FETCH_DISTRIBUTORSTATUS_INIT_ACTION,
  FETCH_DISTRIBUTORSTATUS_SUCCESS_ACTION,
  FETCH_DISTRIBUTORSTATUS_FAIL_ACTION,
  FETCH_DETAILVIEW_INIT_ACTION,
  FETCH_DETAILVIEW_SUCCESS_ACTION,
  FETCH_DETAILVIEW_FAIL_ACTION,
  FETCH_DISTRIBUTORORGSTATUS_INIT_ACTION,
  FETCH_DISTRIBUTORORGSTATUS_SUCCESS_ACTION,
  FETCH_DISTRIBUTORORGSTATUS_FAIL_ACTION,
} from "./action";

import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* fetchdistributors(value) {
  const token = localStorage.getItem("token");
  let pageno = !value.value
    ? 1
    : value.value.pageno === undefined
    ? 1
    : value.value.pageno;
  let status = !value.value
    ? ""
    : value.value.filter === ""
    ? ""
    : value.value.filter;
  let query = !value.value
    ? ""
    : value.value.queryToSearch === ""
    ? ""
    : value.value.queryToSearch;

  // console.log(token);
  try {
    const res = yield fetch(
      `${appConfig.ip}/users?role=distributor&limit=10&page=` +
        pageno +
        `&status=` +
        status +
        `&search=` +
        query,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_DISTRIBUTORS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DISTRIBUTORS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchdistributorstatus(value) {
  let data =
    value.value.item.status === "active"
      ? { status: "suspended" }
      : { status: "active" };

  const id = value.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/users/changeStatus/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      console.log(resJSON);

      yield put({
        type: FETCH_DISTRIBUTORORGSTATUS_INIT_ACTION,
      });

      try {
        const res = yield fetch(`${appConfig.ip}/orgProf/` + id, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(data)
        });
        if (!res.ok) {
          let errJSON = {};
          try {
            errJSON = yield res.json();
          } catch {}
          throw Object.assign(res, errJSON);
        } else {
          let resJSON = yield res.json();

          yield put({
            type: FETCH_DISTRIBUTORORGSTATUS_SUCCESS_ACTION,
            payload: resJSON,
          });

          yield toast.success("Status changed successfully", {
            autoClose: 3000,
          });
        }
      } catch (err) {
        yield put({
          type: FETCH_DISTRIBUTORORGSTATUS_FAIL_ACTION,
          error: err,
        });
      }

      yield put({
        type: FETCH_DISTRIBUTORSTATUS_SUCCESS_ACTION,
        payload: resJSON,
      });
     
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DISTRIBUTORSTATUS_FAIL_ACTION, error: err });
    } else {
    }
  }
  yield put({
    type: FETCH_DISTRIBUTORS_INIT_ACTION,
  });
}

function* fetchdistributordetail(value) {
  // console.log(value);
  const userId = value ? value.value : null;

  const token = localStorage.getItem("token");
  // console.log(token);
  try {
    const res = yield fetch(`${appConfig.ip}/orgProf/` + userId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_DETAILVIEW_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DETAILVIEW_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* distributorActionWatcher() {
  yield takeEvery(FETCH_DISTRIBUTORS_INIT_ACTION, fetchdistributors);
  yield takeEvery(FETCH_DISTRIBUTORSTATUS_INIT_ACTION, fetchdistributorstatus);
  yield takeEvery(FETCH_DETAILVIEW_INIT_ACTION, fetchdistributordetail);
}
